<template>
    <div class="MhRadio">
      <el-radio
        v-for="o in item.options||ajaxOptions"
        :key="o[item.key]"
        :label="o[item.key]"
        :disabled="o[item.disabled]"
      >
        {{o[item.label]}}
      </el-radio>
    </div>

</template>

<script>
export default {
  name: 'MhRadio',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      ajaxOptions: []
    }
  },
  methods: {
    loadAjaxOptions: async function () {
      const that = this
      const { url, para } = that.item
      if (url) {
        const { data: res } = await that.$http.post(url, para)
        that.ajaxOptions = res.data
      }
    }
  },
  created () {
    this.loadAjaxOptions()
  }
}
</script>

<style lang="less" scoped>

</style>
